import {Leads, LinkButton, Text} from '@logistics-frontend/blocks'
import React from 'react'

import {ButtonItem} from 'src/api/cargo-c2c'
import {tagToUrl} from 'src/utils'

import {TextItem} from '../text-item'
import {classes} from './Payment.styles'
import {usePaymentButton} from './PaymentButton.hooks'

type Props = {
  item: ButtonItem
  url: string
}

export function PaymentButton({item, url}: Props): React.ReactElement {
  const {enabled, title, lead_icon: leadIcon, subtitle} = item
  const goToPaymentPage = usePaymentButton()

  return (
    <LinkButton
      alignItems="center"
      disabled={!enabled}
      href={url}
      // @ts-expect-error тут тоже хендлеру нужен ивент. надо отрефакторить нахер
      onClick={goToPaymentPage}
      variant="action"
      fullWidth
      newTab
    >
      {leadIcon && (
        <Leads.Icon>
          <img alt="" className={classes.icon} loading="lazy" src={tagToUrl(leadIcon.image_tag)} />
        </Leads.Icon>
      )}
      <Text align="center">
        <TextItem item={title} />
        {subtitle && <TextItem item={subtitle} />}
      </Text>
    </LinkButton>
  )
}
